<template>
  <main>
    <div class="md-layout md-alignment-center">
      <!-- 利用者・部門管理者 -->
      <md-card class="md-layout-item md-size-75 md-small-size-100 mb-40" v-if="!sent">
        <md-card-content>
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-35 md-small-size-100">
              <div class="md-title">利用者・部門管理者</div>
            </div>
            <div class="md-layout-item md-size-65 md-small-size-100">
              <div class="md-headline">ID・パスワードをお忘れの方</div>
              管理者の方がID・パスワードを管理されていますので、<br>
              お手数ですが管理者の方へお問い合わせください。
            </div>
          </div>
        </md-card-content>
      </md-card>

      <!-- 管理者 -->
      <md-card class="md-layout-item md-size-75 md-small-size-100 mb-40" v-if="!sent">
        <md-card-content>
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-35 md-small-size-100">
              <div class="md-title">管理者</div>
            </div>
            <div class="md-layout-item md-size-65 md-small-size-100">
              <!-- IDをお忘れの方 -->
              <div class="md-headline">IDをお忘れの方</div>
              <p>お手数ですが、JONへお問い合わせください。</p>
              <md-card>
                <md-card-content>
                  <ul>
                    <li>お電話：03-6240-1229</li>
                    <li>メール：jon-web_info@jon.co.jp</li>
                  </ul>
                </md-card-content>
              </md-card>
              <p class="md-caption">
                ※メールは管理者メールアドレスからお送りください。管理者メールアドレス以外でのお問い合わせやお電話でお問い合わせをいただいた場合は、本人様確認のため管理者メールアドレスをお聞きしメールでIDをお知らせします。</p>

              <hr/>
              <!-- パスワードをお忘れの方 -->
              <div class="md-headline">パスワードをお忘れの方</div>
              <p>下記フォームよりパスワードの再発行を行ってください。<br>
                再発行用のURLが記載されたメールが送られます。</p>
              <md-card>
                <md-card-content>
                  <flash-message v-if="errorMessages.length" :errors="errorMessages"></flash-message>
                  <div class="md-layout md-alignment-center-center">
                    <div class="md-layout-item md-size-55">
                      <md-field :class="getValidationClass('email')">
                        <label>メールアドレス</label>
                        <md-input type="email" v-model="form.email" autofocus required :disabled="sending"/>
                        <span class="md-error"
                              v-if="getValidationResponseMessage('email')">{{
                            getValidationResponseMessage('email')
                          }}</span>
                        <span class="md-error" v-else-if="!$v.form.email.required">{{ errors.email.required }}</span>
                        <span class="md-error" v-else-if="!$v.form.email.email">{{ errors.email.email }}</span>
                      </md-field>
                      <md-field :class="getValidationClass('username')">
                        <label>ログインID</label>
                        <md-input type="text" v-model="form.username" required :disabled="sending"/>
                        <span class="md-error"
                              v-if="getValidationResponseMessage('username')">{{
                            getValidationResponseMessage('username')
                          }}</span>
                        <span class="md-error" v-else-if="!$v.form.username.required">{{
                            errors.username.required
                          }}</span>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-size-45">
                      <md-button class="md-primary md-raised" type="submit" @click="onSubmit()" :disabled="sending">
                        <md-icon>mail</md-icon>
                        <span>パスワードの再発行</span>
                      </md-button>
                    </div>
                  </div>
                  <div class="md-layout md-alignment-center-center">
                    <div class="md-layout-item">
                      <loading-spinner v-if="sending"></loading-spinner>
                    </div>
                  </div>
                </md-card-content>
              </md-card>
              <p class="md-caption">※管理者の方のID・メールアドレスをご入力ください。<br>
                ※複数人でお使いのメールアドレスをご登録されている場合は、全ての方にパスワード再発行用のメールが送られますので、ご注意ください。</p>
            </div>
          </div>
        </md-card-content>
      </md-card>

      <!-- メールを送信しました -->
      <md-card class="md-layout-item md-size-75 md-small-size-100 mb-40" v-if="sent">
        <md-card-content>
          <h2 class="md-title">メールを送信しました。</h2>
          <p>
            ご指定のメールアドレスへメールを送信いたしました。<br>
            メール本文にありますURLからパスワード再発行に進んでください。
          </p>
          <br>
          <p class="md-body-1">※確認メールが届かない場合、下記をご確認ください。</p>
          <p class="md-caption">
            ・迷惑メールフォルダにメールが振り分けられている可能性がありますので、迷惑メールフォルダも含めご確認ください。<br>
            ・ドメイン指定受信など、一部のメールが届かなくなる設定にしていると、パスワード再発行メールが届かない場合があります。<br>
            ・「no-reply@jon-payment.com」または「jon-web_info@jon.co.jp」からのメールを受信できるように設定してください。<br>
            ・メールアドレスを間違って入力した可能性があります。再度「
            <a :href="$router.resolve({name: 'ForgotAccount'}).href">ID・パスワードをお忘れの方</a>
            」より登録を行ってください
          </p>
        </md-card-content>
      </md-card>
    </div>
  </main>
</template>

<script>
import FlashMessage         from "../../components/FlashMessage";
import CommonMixin          from "../../mixins/commonMixin";
import {validationMixin}    from 'vuelidate'
import Validation           from "../../modules/validation";
import {email, required}    from "vuelidate/lib/validators";
import {apiClient, apiList} from "../../modules/apiClient";
import LoadingSpinner       from "../../components/LoadingSpinner";

export default {
  name      : 'ForgotAccount',
  components: {LoadingSpinner, FlashMessage},
  mixins    : [validationMixin, CommonMixin],
  data      : () => ({
    sending: false,
    sent   : false,
    form   : {
      email   : null,
      username: null,
    },
    errors : {
      email   : {
        required: Validation.errorMessage(Validation.rules.required, 'email'),
        email   : Validation.errorMessage(Validation.rules.email, 'email'),
      },
      username: {
        required: Validation.errorMessage(Validation.rules.required, 'username'),
      },
    },
  }),
  validations() {
    return {
      form: {
        email   : {
          required,
          email,
        },
        username: {
          required,
        },
      }
    };
  },
  methods: {
    clearForm() {
      this.successMessage   = [];
      this.errorMessages    = [];
      this.validateResponse = [];
    },
    onSubmit() {
      this.clearForm()
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.sending = true;
      apiClient.post(apiList.forgot_account, this.form)
          .then(response => {
            if (this.hasResponseErrors(response)) {
              return;
            }
            this.sent = true;
          })
          .catch(error => {
            this.errorMessages = [error.message];
          })
          .finally(() => {
            this.sending = false
            this.$v.$reset()
          });
    },
  }
}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/components";

ul {
  li {
    list-style-type: none;
  }
}

.mb-40 {
  margin-bottom: 40px;
}

hr {
  border: 0.1px solid #ccc;
  margin-top: 30px;
  margin-bottom: 30px;
}

.md-card .md-card.md-theme-default {
  background-color: #fafafa;
}
</style>
